var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 200,
    viewBox: "0 0 200 200",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#0cc",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.498 100.002c0 6.875 5.6251 12.5 12.5 12.5h75l12.5-12.5-12.5-12.5h-75c-6.8749 0-12.5 5.6249-12.5 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.004 43.75c-31.0626 0-56.2501 25.1875-56.2501 56.25 0 31.063 25.1875 56.25 56.2501 56.25h31.25l25-25h-56.25c-17.2502 0-31.2501-14-31.2501-31.25 0-17.2499 13.9999-31.25 31.2501-31.25h56.25l-25-25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.9999 0c-55.25 0-99.9999 44.7501-99.9999 100 0 55.25 44.7499 100 99.9999 100h100.0001v-25h-100.0001c-41.4375 0-74.9999-33.562-74.9999-75 0-41.4374 33.5624-75 74.9999-75h100.0001v-25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.25 68.75h18.75v-25h-43.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.25 156.252h43.75v-25h-18.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCex);
export default __webpack_public_path__ + "static/media/cex.c87034cbc60ddb45de92bf024fd93293.svg";
export { ForwardRef as ReactComponent };